var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSfs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.29,
    height: 41.18,
    viewBox: "0 0 80.29 41.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#eb3c24;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.4,31.78A3.7,3.7,0,0,0,2,35.63a3.64,3.64,0,0,0,3.5,3.77H75.53s3.1,0,3.1-3.81-3.13-3.81-3.13-3.81Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.35,21.67a3.51,3.51,0,0,0-3.49,3.76,3.51,3.51,0,0,0,3.49,3.77h13.9s7.67.24,7.67-8.82-7.67-8.79-7.67-8.79H62.81a1.17,1.17,0,0,1-1.14-1.32,1.19,1.19,0,0,1,1.14-1.34H75.52a3.84,3.84,0,0,0,3.4-3.84,4,4,0,0,0-3.4-3.93H61.68s-7.82,0-7.82,9.17S61.68,19,61.68,19h8.54a1.07,1.07,0,0,1,1,1.18,1.53,1.53,0,0,1-1,1.48Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.4,21.61a3.5,3.5,0,0,0-3.48,3.76A3.51,3.51,0,0,0,5.4,29.14H19.31S27,29.38,27,20.31s-7.67-8.79-7.67-8.79H10.87A1.17,1.17,0,0,1,9.74,10.2a1.18,1.18,0,0,1,1.13-1.34H23.58A3.84,3.84,0,0,0,27,5a4,4,0,0,0-3.4-3.93H9.74s-7.82,0-7.82,9.17,7.82,8.69,7.82,8.69h8.54a1.07,1.07,0,0,1,1,1.18,1.53,1.53,0,0,1-1,1.48Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.36,26.17s.05,3,4,3,3.91-3,3.91-3V19H49.06s3-.05,3-3.75-3-3.67-3-3.67H37.24V8.92H49.06s3-.21,3-4-3-3.8-3-3.8h-16S29.36,1.44,29.36,5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSfs);
export default __webpack_public_path__ + "static/media/SFS.115bf6f30a180928a771b8bbed22cd05.svg";
export { ForwardRef as ReactComponent };